var codeblock_default = {
  "blockStyleSpacing": "-xUK-",
  "codeBlock": "_8w0Ik -xUK-",
  "renderedInTable": "_2qNL2"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
